module.exports = {
  STATUS: {
    ACTIVE: 1,
    INACTIVE: 0
  },
  CONTRACT_TEMPLATE: "contract-template",
  CLIENT_CONTRACT_TEMPLATE: 'client-contract-template',
  RATE_TEMPLATE: 'rate-template',
  POD_HARD_COPY_REQUIRED: {
    YES: 1,
    NO: 2
  },
  BILLING_DATA: {
    MONTHLY: 1,
    FORTNIGHTLY: 2,
    WEEKLY: 3
  },
  PAYMENT_MODE: {
    CHEQUE: 1,
    DEMAND_DRAFT: 2,
    RTGS: 3
  },
  CITY_TO_CITY: 1,
  ZONE_TO_ZONE: 2,
  FROM_EDIT: "fromEdit",
  PER_PAGE_DATA: 10,
  PER_PAGE_HTD_DATA:20,
  AWB_LENGTH_LIMIT: 10,
  MPS_LENGTH_LIMIT: 7,
  MINCFT:3,
  SLAB_TYPE: {
    WEIGHT: 1,
    INVOICE_AMOUNT: 2,
    DISTANCE: 3,
    QUANTITY: 4,
  },
  WEIGHT_TYPE: {
    BILLABLE_WEIGHT: 1,
    PHYSICAL_WEIGHT: 2,
    VOLUMETRIC_WEIGHT: 3
  },
  SLAB_SYMBOL_CONFIG: {
    LESS_THAN_EQUAL_TO: "lte",
    GREATER_THAN_EQUAL_TO: "gte",
    LESS_THAN: "lt",
    GREATER_THAN: "gt"
  },
  RISK_OF_THEFT: {
    HIGH: 1,
    MEDIUM: 2,
    LOW: 3
  },
  INSURANCE_CHARGE_TYPE: {
    FOV_CHARGE: 1,
    FLAT_CHARGE: 2
  },
  BASE_RATE_TYPE:{
    FLAT: 1,
    SLAB: 2
  },
  FOV_TYPE: {
    FLAT: 1,
    SLAB: 2
  },
  RTO_CHARGES: {
    SAME_AS_FORWARD_CHARGES: 1,
    CHOOSE_FROM_A_RATE_LIST: 2
  },
  ACCESSORIAL_RATE_TYPE: {
    FLAT: 1,
    SLAB: 2
  },
  ACCESSORIAL_CHARGE_PAY_TYPE: {
    DOCKET: 1,
    PERCENT: 2
  },
  CONTRACT_STATUS: {
    0: "Draft",
    1: "Sent For Approval",
    2: "Approved",
    3: "Reject"
  },
  BOOKING_STATUS: {
    0: "Pending",
    1: "Booked",
    2: "PickUp",
    3: "HubInscan",
    4: "OFD"
  },
    BOOKING_MODE: {
    'Credit': "Credit",
    'PrePaid': "Prepaid",
    'To Pay': "FTC",
    'Cash': "Cash"
  },
  RATE_BASIS: {
    WEIGHT : 1,
    QUANTITY : 2
  },
  SLAB_TARIFF_TYPE:{
    WEIGHT : 1,
    QUANTITY : 2
  },
  SLAB_CHARGE_TYPE:{
    INCREMENTAL: 1,
    ABSOLUTE: 2
  },
  PICKUP_STATUS:{
    0: "Pending",
    1: "Allocated",
    2: "OFP",
    3: "In-Progress",
    4: "Fulfilled",
    5 : 'Unpicked',
    6 : 'Not fulfilled'
  },
}



// WEBPACK FOOTER //
// ./src/modules/shared/constants/constant.js